import React, { useEffect } from 'react';
import { Button, Box, Typography, Paper } from '@mui/material';
import { signInWithPopup, onAuthStateChanged } from 'firebase/auth';
import { auth, provider } from './firebase';

const Login = ({ onLogin }) => {
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      if (user) {
        onLogin(user);
        //const token = firebase.auth().currentUser.getIdToken();
        auth.currentUser?.getIdToken()
          .then(token => {
          console.log(token);
         })
        .catch(err => {
          console.error("Failed to get ID token:", err);
        });
      }
    });
    return () => unsubscribe();
  }, [onLogin]);

  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      onLogin(result.user);
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>
          Panda Recipes Manager Login
        </Typography>
        <Button variant="contained" onClick={handleLogin}>
          Sign in with Google
        </Button>
      </Paper>
    </Box>
  );
};

export default Login;
